import { render } from "./securityComponent.vue?vue&type=template&id=42566f7c&scoped=true"
import script from "./securityComponent.vue?vue&type=script&lang=js"
export * from "./securityComponent.vue?vue&type=script&lang=js"

import "./securityComponent.vue?vue&type=style&index=0&id=42566f7c&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42566f7c"]])

export default __exports__